import {LayerEsriMapServer, localCacheUrl, makeServiceUrl} from "webmapsjs/dist/layers/LayerEsriMapServer";
// import {valsMetrics, valsTimePeriod} from "./store";
import {LayerBase} from "webmapsjs/dist/layers";

// import $ = require("jquery");


let minZoomCached = 4;
let maxZoomCached = 8;

let mpaOpacity = 1;
let mpaLayers = [0, 1];

// Years to show, starting with 2017
export const YEAR_COUNT = 7

export const LEFT_YEAR = 2022;
export const RIGHT_YEAR = 2023;


export const valsMetrics = ['LOTTR', 'TTTR', 'Delay'];
// export const valsMetricsDescrip = ['level of travel time reliability (ratio)', 'truck travel time reliability (index)', 'person-hours'];

// export const valsInterstate = ['Interstate', 'Non Interstate'];
// export const valsInterstateDescrip = ['Interstate', 'Non Interstate'];

export const valsTimePeriod = ['AM Peak', 'Mid Day', 'PM Peak', 'Overnight', 'Weekend', 'Maximum'];



export const cachedMpa = new LayerEsriMapServer(
    localCacheUrl('NPMRDS', 'mpa_bounds'),
    {
        minZoom: minZoomCached,
        maxZoom: maxZoomCached,
        showLayers: mpaLayers,
        visible: true,
        name: 'mpa_cache',
        getLegend: false,
        opacity: mpaOpacity
    });

export const dynamicMpa = new LayerEsriMapServer(
    makeServiceUrl('NPMRDS', 'mpa_bounds'),
    {
        minZoom: maxZoomCached + 1,
        showLayers: mpaLayers,
        visible: true,
        name: name + 'mpa_dyn',
        getLegend: false,
        opacity: 0.2
    });

dynamicMpa.opacity = 0.2;


const layerLookup = {};
export const allLayers: LayerBase[] = [];

for (let i = 0; i < YEAR_COUNT * 36; i++) {

    let isInterstate = Math.floor(i / 18) % 2 == 0;
    let metric = valsMetrics[Math.floor(i / 6) % 3];
    let timePeriod = valsTimePeriod[i % 6];
    let year = (2017 + Math.floor(i / 36)).toFixed()

    let _name = `${year}-${isInterstate ? 'int' : 'non_int'}-${metric}-${timePeriod}-`;

    let cached = new LayerEsriMapServer(
        localCacheUrl('NPMRDS', 'compare_2017_2018'),
        {
            minZoom: minZoomCached,
            maxZoom: maxZoomCached,
            showLayers: [i],
            visible: false,
            name: _name + 'cache',
            getLegend: false,
            zIndex: isInterstate ? 7 : 5
        });

    let dynamic = new LayerEsriMapServer(
        makeServiceUrl('NPMRDS', 'compare_2017_2018'),
        {
            minZoom: maxZoomCached + 1,
            showLayers: [i],
            visible: false,
            name: _name + 'dyn',
            getLegend: false,
            zIndex: isInterstate ? 7 : 5
        });

    if (!layerLookup[year]) {
        layerLookup[year] = {};
    }

    if (!layerLookup[year][metric]) {
        layerLookup[year][metric] = {};
    }

    if (!layerLookup[year][metric][timePeriod]) {
        layerLookup[year][metric][timePeriod] = {};
    }

    if (isInterstate) {
        layerLookup[year][metric][timePeriod]['int'] = [cached, dynamic]
    } else {
        layerLookup[year][metric][timePeriod]['non_int'] = [cached, dynamic]
    }

    allLayers.push(cached);
    allLayers.push(dynamic);

}

export function getLayers(yr: number, metric: string, timeP: string, ints: boolean, nonInt: boolean): LayerBase[] {
    let l = layerLookup[yr.toFixed()][metric][timeP];

    let outLayers = [];

    if (ints) {
        for (let ly of l['int']) {
            outLayers.push(ly)
        }
    }

    if (nonInt) {
        for (let ly of l['non_int']) {
            outLayers.push(ly)
        }
    }

    return outLayers;

}


function esriStyleConvert(obj) {


    let outHtml = '';

    outHtml += `<img src="data:${obj.contentType};base64,${obj['imageData']}"/>&nbsp;`;
    outHtml += obj.label;

    return outHtml;
}


function makeLegendHtml(leg: Object, lyr: number): string {

    let legendInfo = '<ul>';

    let legendItems = leg['layers'][lyr]['legend'];

    for (let itm of legendItems) {
        legendInfo += `<li>${esriStyleConvert(itm)}</li>`;
    }
    legendInfo += '</ul>';

    return legendInfo;
}

 let legendData = {};
let lottrLegend: string = '';
let ttrLegend: string = '';

export interface iDelayLegend {
    'AM Peak': string;
    'Mid Day': string;
    'PM Peak': string;
    'Overnight': string;
    'Weekend': string;
    'Maximum': string;
}

const delayLegend: iDelayLegend = {
    'AM Peak': '',
    'Mid Day': '',
    'PM Peak': '',
    'Overnight': '',
    'Weekend': '',
    'Maximum': '',
}



$.get(makeServiceUrl('NPMRDS', 'compare_2017_2018_legend') + '/legend?f=pjson',
    {}, (d) => {

        lottrLegend = makeLegendHtml(d, 0);
        ttrLegend = makeLegendHtml(d, 1);

        delayLegend['AM Peak'] = makeLegendHtml(d, 2);
        delayLegend['Mid Day'] = makeLegendHtml(d, 3);
        delayLegend['PM Peak'] = makeLegendHtml(d, 4);
        delayLegend['Overnight'] = makeLegendHtml(d, 5);
        delayLegend['Weekend'] = makeLegendHtml(d, 6);
        delayLegend['Maximum'] = makeLegendHtml(d, 7);
        //
        // // console.log(d);
        // for (let i = 0; i < 16; i++) {
        //
        //     let metric = valsMetrics[Math.floor(i / 6) % 3];
        //     let timePeriod = valsTimePeriod[i % 6];
        //     let l = d['layers'][i]['legend'];
        //
        //     if (!legendData[metric]) {
        //         legendData[metric] = {};
        //     }
        //
        //
        //
        //     legendData[metric][timePeriod] = makeLegendHtml(d, i);
        // }
    }, 'json');

export function getLeg(metric: string, tim: string): string{

    if (metric === 'LOTTR'){
        return lottrLegend;
    } else if (metric === 'TTTR'){
        return ttrLegend;
    } else {
        return delayLegend[tim];
    }
        //
        // console.log(metric, tim)
        // if (!legendData[metric]){
        //         return "";
        // }
        //
        // if (!legendData[metric][tim]){
        //         return "";
        // }
        //
        // return legendData[metric][tim];
}


